/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_SavingInputs */

const en_us2_onboarding_saving = /** @type {(inputs: Onboarding_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving your answers…`)
};

const pt_br2_onboarding_saving = /** @type {(inputs: Onboarding_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvando suas respostas…`)
};

const es_419_onboarding_saving = /** @type {(inputs: Onboarding_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardando tus respuestas…`)
};

const pt_pt2_onboarding_saving = /** @type {(inputs: Onboarding_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A guardar as tuas respostas…`)
};

const fr_fr2_onboarding_saving = /** @type {(inputs: Onboarding_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement de tes réponses…`)
};

const de_de2_onboarding_saving = /** @type {(inputs: Onboarding_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Antworten werden gespeichert…`)
};

const it_it2_onboarding_saving = /** @type {(inputs: Onboarding_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio delle risposte…`)
};

/**
* | output |
* | --- |
* | "Saving your answers…" |
*
* @param {Onboarding_SavingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_saving = /** @type {((inputs?: Onboarding_SavingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_SavingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_saving(inputs)
	if (locale === "es-419") return es_419_onboarding_saving(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_saving(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_saving(inputs)
	if (locale === "de-DE") return de_de2_onboarding_saving(inputs)
	if (locale === "it-IT") return it_it2_onboarding_saving(inputs)
	return en_us2_onboarding_saving(inputs)
});
export { onboarding_saving as "onboarding.saving" }